// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__A18EX","label":"CategoryService_label__jnwcr","location":"CategoryService_location__2EKHL"};